import { useCallback } from "react";
import { useModal } from "@racoon/ui";
import { ConnectProto } from "@racoon/api";
import { RouteTransferModalContent } from "../components/msw-route-list/RouteTransferModal";

export interface OpenAddJobsToRoutePickerOptions {
  /** Jobs that are on no route yet — the rows checked in the orders table. */
  jobs: ConnectProto.Job[];
  /** Day the vehicle/shift list opens on (defaults to today inside the modal). */
  initialDate?: Date;
  onAdded?: () => void;
}

/**
 * "Add jobs to route" from the job side: the jobs are known and the target trip
 * is what has to be picked, so the transfer modal is opened in its `unassigned`
 * mode (vehicle → shift → trip, then UpdateRouteWithJobs).
 *
 * The mirror entry point — a known route, pick the jobs — is
 * `useAddJobsToRouteModal`.
 */
export function useAddJobsToRoutePickerModal() {
  const { openModal, closeModal } = useModal();

  const openAddJobsToRoutePicker = useCallback(
    ({ jobs, initialDate, onAdded }: OpenAddJobsToRoutePickerOptions) => {
      const modalId = openModal({
        size: "2xl",
        width: { md: "min(1200px, 94vw)" },
        bodyClassName: "flex flex-col flex-1 !p-0 min-h-0",
        closeButtonTop: "top-4",
        body: (
          <RouteTransferModalContent
            mode="unassigned"
            unassignedJobs={jobs}
            initialDate={initialDate}
            onClose={() => closeModal(modalId)}
            onSuccess={() => onAdded?.()}
          />
        ),
      });
      return modalId;
    },
    [openModal, closeModal],
  );

  return { openAddJobsToRoutePicker };
}
